var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('i',{staticClass:"empty__icon fe fe-alert-circle"}),_c('div',{staticClass:"empty__text"},[_vm._v(_vm._s(_vm.message))]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }